import Hero from './components/Hero';
import InsightsGrid from './components/InsightsGrid';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#f5f1e8]">
      <Hero />
      <InsightsGrid />
      <Footer />
    </div>
  );
}
